import React, { FunctionComponent } from "react";
import FaceSelectMenu from "../toolbarComponents/FaceSelectMenu";
import LockHorzRotation from "../toolbarComponents/LockHorzRotation";
import Reset from "../toolbarComponents/Reset";
import ShowAxisHelper from "../toolbarComponents/ShowAxisHelper";
import Snapshot from "../toolbarComponents/Snapshot";
import TogglePins from "../toolbarComponents/TogglePins";
import Toolbar from "../toolbarComponents/Toolbar";
import BackgroundColorPicker from "../toolbarComponents/BackgroundColorPicker";
import { useStore } from "csi/state/hooks";
import { observer } from "mobx-react-lite";
import AvatarToggle from "../toolbarComponents/AvatarToggle";

const ThreeDViewerToolbar: FunctionComponent = observer(() => { 
	const rootStore = useStore();
	const { threeDStore } = rootStore;
	const { addBackgroundColor, resetColorPickerToDefault } = threeDStore;
	return (
		<Toolbar>
			<TogglePins />
			<ShowAxisHelper />
			<AvatarToggle />
			<BackgroundColorPicker onChange={addBackgroundColor} resetBackgroundColorToDefault={resetColorPickerToDefault} />    
			<LockHorzRotation />
			<FaceSelectMenu />
			<Snapshot />
			<Reset />  
		</Toolbar>
	);
});

export default ThreeDViewerToolbar;
